export default __webpack_public_path__ + "static/media/group-presentation-image.20c1f874.png";